module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_02.e7f8f256.svg";